import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import EmailBlasterMain from "components/menu/email-blaster/main";

const EmailBlasterRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={EmailBlasterMain}
            />
        </Switch>
    </div>
);

export default connect()(EmailBlasterRouter);
